/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useFormatters } from "../../hooks/useFormatters";
import { formatDatePeriod as formatDatePeriodUtil } from "../../utils/helpers/formatters";

const FormatDatePeriod = ({
  from,
  to,
  format,
  type = formatDatePeriodUtil.TYPE.LONG,
  custom_format,
  mergeDate,
}) => {
  const { FormatDatePeriod: formatDatePeriod } = useFormatters();

  return formatDatePeriod({ from, to, format, type, custom_format, mergeDate });
};

FormatDatePeriod.FORMAT = formatDatePeriodUtil.FORMAT;
FormatDatePeriod.TYPE = formatDatePeriodUtil.TYPE;

export default FormatDatePeriod;
